import React from "react";

const Product = () => {
  return (
    <div>
      <h1>Product</h1>
      <p>Welcome to the Product page!</p>
    </div>
  );
};

export default Product;
